import React, { useEffect, useRef, useState } from 'react';

import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';

import { Api } from '../../services/api';

const HelpList = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [orgType, setOrgType] = useState([]);
    const [searchOrgType, setSearchOrgType] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const toast = useRef(null);
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);

    // -------------------------------------------------------------
    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const [pageNumber, setPageNumber] = useState(0);
    const projectsPerPage = 5;
    const pagesVisited = pageNumber * projectsPerPage;
    const [type, setType] = useState('Add');
    const [title, setTitle] = useState('Add Project Type');
    const [orgTypeID, OrgTypeID] = useState();
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [globalFilter, setGlobalFilter] = useState('');
    // -------------------------------------------------------------

    const formik = useFormik({
        initialValues: {
            title: '',
            first_name: '',
            last_name: '',
            status: 'Y',
            password: '',
            email: '',
            image: null,
            //   color_code: '',
        },

        validate: (data) => {
            let errors = {};
            if (!data.title) {
                errors.title = 'Title is required.';
            }
            if (!data.email) {
                errors.email = 'Emil is required.';
            }
            if (!data.password) {
                errors.password = 'Password is required.';
            }
            return errors;
        },
        onSubmit: (data) => {
            // Determine the URL based on the type
            let url = Api.API_BASE_URL + 'add-organization';
            if (type === "Edit") {
                url = Api.API_BASE_URL + 'update-organization/' + orgTypeID;
            }

            // Retrieve the token from localStorage
            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };

            // Perform the fetch request with the updated headers
            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((json) => {
                    if (json.error) {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: json.error });
                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: json.result });
                        closeModal();
                        getOrgType();
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });

            console.log(data);
        }

    });
    // -------------------------------------------------------------

    const closeModal = () => {
        setIsModalOpen(false);
        setIsDeleteConfirmationModalOpen(false);
    };


  

    const [orgShow, setOrgShow] = useState("N");

    useEffect(() => {
        console.log('Fetching projects...xx');
        var organizationId = localStorage.getItem('organizationId');
        if (organizationId == "66f6989c2191596fe7f1c46f" || organizationId == "66f16bb68657dd00c9332538") {
            setOrgShow("Y");

        }
        getOrgType();
    }, []);

    const getOrgType = (project) => {
        // Retrieve the token from localStorage
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Authorization': token ? `Bearer ${token}` : ''
        };

        // Make the GET request with token in the Authorization header
        axios.get(Api.API_BASE_URL + 'help/get', { headers })
            .then((response) => {
                const data = response.data.result;
                setOrgType(data);
                setSearchOrgType(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setIsLoading(false);
            });
    };


    const header = (
        <div className="flex flex-wrap  align-items-center justify-content-between m-0 "> 
            <div>
            </div>
        </div>
    );

    return (
        <>
            <div className="pagee-container mt-2">
                <Toast ref={toast} />
                <ConfirmDialog />
                <div className="pagination-datable-height">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <DataTable

                            value={orgType}
                            paginator
                            rows={12}
                            key="id"
                            tableStyle={{ minWidth: '50rem' }}
                            selectionMode="single"
                            selection={selectedProduct}
                            // onRowSelect={onRowSelect}
                            onSelectionChange={(e) => setSelectedProduct(e.value)}
                            header={header}
                            globalFilter={globalFilter || ''}
                            emptyMessage="No records found"
                        >

                            {/* <Column body={actionBodyTemplate} header="Action" exportable={false} style={{ width: '100px', alignItems: 'center', textAlign: 'center' }}></Column> */}
                            <Column field="title" header="Organization Name" ></Column>
                            <Column field="name" header="Name" ></Column>
                            {/* <Column field="last_name" header="Last Name" ></Column> */}
                            <Column field="description" header="Description" ></Column>
                            {/* <Column field="image" header="Attachment" ></Column> */}
                            {/* <Column field="status" header="Status" body={statusBodyTemplate} /> */}
                            <Column field="status" header="Status"  />

                        </DataTable>
                    )}
                </div>
            </div>

           
        </>
    )
}

export default HelpList